package ir.alirezaivaz.finglish.ui.theme

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import ir.alirezaivaz.finglish.dto.Language.Companion.typography
import ir.alirezaivaz.finglish.utils.LocalAppLocale
import ir.alirezaivaz.finglish.utils.SettingsManager
import ir.alirezaivaz.finglish.utils.Utils

@Composable
fun FinglishTheme(
    content: @Composable () -> Unit
) {
    val appLocale = LocalAppLocale.current
    val theme by SettingsManager.theme.collectAsState()
    val isDynamicColors by SettingsManager.isDynamicColors.collectAsState()
    MaterialTheme(
        colorScheme = Utils.getColorScheme(theme, isDynamicColors),
        typography = appLocale.typography,
        content = content
    )
}
